/* Temporary compatibility for Snap's synchronous native-submit continuation. */
(function () {
  'use strict';

  if (window.__awareSnapSubmitCompat || !window.HTMLFormElement) return;
  var nativeRequestSubmit = HTMLFormElement.prototype.requestSubmit;
  if (typeof nativeRequestSubmit !== 'function') return;
  window.__awareSnapSubmitCompat = true;

  var states = new WeakMap();
  var marker = 'snapB2bHidePriceGateBypass';
  var owns = Object.prototype.hasOwnProperty;

  function snapshot(form) {
    try {
      var action = new URL(form.action, document.baseURI);
      if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return null;
      if (form.method.toLowerCase() !== 'post') return null;
      var values = [];
      var hasFile = false;
      new FormData(form).forEach(function (value, key) {
        if (typeof value !== 'string') hasFile = true;
        values.push([key, value]);
      });
      if (hasFile) return null;
      return JSON.stringify([action.href, form.method, form.enctype, form.target, values]);
    } catch (error) {
      // Unsupported forms keep their existing submission behavior.
      return null;
    }
  }

  function restore(form, state) {
    if (!state.wrapper) return;
    var descriptor = Object.getOwnPropertyDescriptor(form, 'requestSubmit');
    if (descriptor && descriptor.value === state.wrapper && descriptor.configurable) {
      delete form.requestSubmit;
    }
  }

  function isRestored(form) {
    return !owns.call(form, 'requestSubmit') && form.requestSubmit === nativeRequestSubmit;
  }

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var previous = states.get(form);
    if (previous) restore(form, previous);
    var state = { generation: previous ? previous.generation + 1 : 1, queued: false };
    states.set(form, state);

    if (!form.isConnected || !form.hasAttribute('data-product-form') ||
        window.__snapB2bHidePriceAtcGate !== true || form.dataset[marker] === 'true' ||
        !isRestored(form) || !Object.isExtensible(form)) return;

    var initial = snapshot(form);
    if (initial === null || states.get(form) !== state) return;

    state.wrapper = function () {
      if (this !== form || arguments.length !== 0 || form.dataset[marker] !== 'true') {
        return nativeRequestSubmit.apply(this, arguments);
      }
      if (state.queued) return;
      state.queued = true;
      window.setTimeout(function () {
        if (states.get(form) !== state || form.dataset[marker] !== 'true') return;
        restore(form, state);
        var unchanged = form.isConnected && snapshot(form) === initial;
        if (states.get(form) !== state || form.dataset[marker] !== 'true') return;
        if (!unchanged) {
          // Only this still-current approval belongs to the canceled payload.
          delete form.dataset[marker];
          return;
        }
        if (!isRestored(form)) return;
        nativeRequestSubmit.call(form);
      }, 0);
    };

    Object.defineProperty(form, 'requestSubmit', {
      configurable: true,
      writable: true,
      value: state.wrapper
    });
    // A later-task vendor continuation sees the original native method.
    window.setTimeout(function () { restore(form, state); }, 0);
  }, true);
})();
